import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenGeriatri";
import { AsesmenGeriatriRecord } from "@/types/asesmen_geriatri";

let requestedRegister: string | null = null;

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-geriatri"
})
class AsesmenGeriatriStore extends VuexModule {
  loading = false;
  data: AsesmenGeriatriRecord | null = null;

  loadedRegisterId: string | number | null = null;

  @Mutation
  SET_RECORD(val: AsesmenGeriatriRecord | null) {
    this.data = val;
  }

  @Mutation
  SET_LOADED_REGISTER(val: string | number | null) {
    this.loadedRegisterId = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.data = null;
    this.loadedRegisterId = null;
    this.loading = false;
  }

  get isLoadedFor() {
    return (registerId: string | number): boolean =>
      this.loadedRegisterId !== null &&
      String(this.loadedRegisterId) === String(registerId);
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    const key = String(registerId);
    requestedRegister = key;
    if (this.loadedRegisterId === null || String(this.loadedRegisterId) !== key) {
      this.SET_RECORD(null);
      this.SET_LOADED_REGISTER(null);
    }
    this.SET_LOADING(true);

    try {
      const response = await Service.getByRegister(registerId);
      if (requestedRegister !== key) return;
      this.SET_RECORD(response.data?.data ?? null);
      this.SET_LOADED_REGISTER(registerId);
    } finally {
      if (requestedRegister === key) {
        this.SET_LOADING(false);
      }
    }
  }

  @Action({ rawError: true })
  reset(): void {
    requestedRegister = null;
    this.RESET_STORE();
  }
}

export default getModule(AsesmenGeriatriStore);
